(() => {
  const drawer = document.getElementById('RvCartDrawer');
  if (!drawer || drawer.dataset.ready === 'true') return;
  drawer.dataset.ready = 'true';
  const panel = drawer.querySelector('.rv-cart-drawer__panel');
  const itemsRoot = drawer.querySelector('[data-rv-cart-items]');
  const recommendations = drawer.querySelector('[data-rv-cart-recommendations]');
  const recommendationsList = drawer.querySelector('[data-rv-cart-recommendations-list]');
  const status = drawer.querySelector('[data-rv-cart-status]');
  const error = drawer.querySelector('[data-rv-cart-error]');
  const goalCopy = drawer.querySelector('[data-rv-cart-goal-copy]');
  const progress = drawer.querySelector('[data-rv-cart-progress]');
  const progressBar = progress.querySelector('span');
  const footer = drawer.querySelector('[data-rv-cart-footer]');
  const threshold = 14500;
  const root = window.Shopify?.routes?.root || '/';
  const currency = window.Shopify?.currency?.active || 'USD';
  let lastTrigger;
  let recommendationsFor;
  const lineUpdates = new Map();

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const setLoading = (loading) => drawer.classList.toggle('is-loading', loading);
  const showError = (message = '') => { error.textContent = message; };
  const showStatus = (message = '') => { status.textContent = message; window.setTimeout(() => { if (status.textContent === message) status.textContent = ''; }, 2600); };
  const updateHeaderCount = (count) => {
    document.querySelectorAll('a[href$="/cart"][aria-label="Cart"]').forEach((link) => {
      let badge = link.querySelector('.rv-cart-count, .rv-head-action__cart-count');
      if (!badge && count > 0) {
        badge = document.createElement('span');
        badge.className = 'rv-head-action__cart-count';
        link.append(badge);
      }
      if (badge) {
        badge.textContent = count;
        badge.hidden = count < 1;
      }
    });
  };
  const open = (trigger) => {
    lastTrigger = trigger || document.activeElement;
    drawer.classList.add('is-visible');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('rv-cart-drawer-open');
    window.setTimeout(() => panel.focus(), 40);
  };
  const close = () => {
    drawer.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('rv-cart-drawer-open');
    lastTrigger?.focus?.();
  };
  const renderItem = (item, index) => {
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="rv-cart-item__variant">${escapeHtml(item.variant_title)}</div>` : '';
    return `<article class="rv-cart-item" data-line="${index + 1}"><a class="rv-cart-item__image" href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.featured_image?.url || item.image || '')}" alt="${escapeHtml(item.product_title)}" width="164" height="164"></a><div class="rv-cart-item__content"><a class="rv-cart-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>${variant}<div class="rv-cart-item__price">${money(item.final_line_price)}</div><div class="rv-cart-item__actions"><div class="rv-cart-item__quantity"><button type="button" data-rv-cart-minus aria-label="Decrease quantity">−</button><input type="number" min="1" max="10" value="${item.quantity}" aria-label="Quantity"><button type="button" data-rv-cart-plus aria-label="Increase quantity">+</button></div><button class="rv-cart-item__remove" type="button" data-rv-cart-remove>Remove</button></div></div></article>`;
  };
  const renderRecommendations = async (cart) => {
    const productId = cart.items[0]?.product_id;
    if (!productId) { recommendations.hidden = true; return; }
    if (recommendationsFor === productId && recommendationsList.children.length) { recommendations.hidden = false; return; }
    try {
      const response = await fetch(`${root}recommendations/products.json?product_id=${productId}&limit=2&intent=related`);
      const data = await response.json();
      const products = (data.products || []).filter((product) => product.available).slice(0, 2);
      recommendationsList.innerHTML = products.map((product) => {
        const variant = product.variants.find((entry) => entry.available) || product.variants[0];
        const compare = variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : '';
        return `<article class="rv-cart-recommendation"><img src="${escapeHtml(product.featured_image || '')}" alt="${escapeHtml(product.title)}" width="108" height="108"><div class="rv-cart-recommendation__copy"><a class="rv-cart-recommendation__title" href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a><div class="rv-cart-recommendation__prices"><strong>${money(variant.price)}</strong>${compare}</div></div><button class="rv-cart-recommendation__add" type="button" data-rv-recommendation-add data-variant-id="${variant.id}" aria-label="Add ${escapeHtml(product.title)} to cart">+</button></article>`;
      }).join('');
      recommendationsFor = productId;
      recommendations.hidden = products.length === 0;
    } catch (_) { recommendations.hidden = true; }
  };
  const render = (cart) => {
    drawer.querySelector('[data-rv-cart-count]').textContent = `(${cart.item_count})`;
    updateHeaderCount(cart.item_count);
    const remaining = Math.max(0, threshold - cart.total_price);
    goalCopy.textContent = remaining > 0 ? `Add ${money(remaining)} for 15% off` : '15% off unlocked';
    const percent = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    progressBar.style.width = `${percent}%`;
    progress.setAttribute('aria-valuenow', Math.min(145, Math.round(cart.total_price / 100)));
    itemsRoot.innerHTML = cart.items.length ? cart.items.map(renderItem).join('') : '<div class="rv-cart-drawer__empty">Your cart is empty.</div>';
    footer.hidden = cart.items.length === 0;
    drawer.querySelector('[data-rv-cart-subtotal]').textContent = money(cart.items_subtotal_price);
    drawer.querySelector('[data-rv-cart-total]').textContent = money(cart.total_price);
    const savings = Math.max(0, cart.items_subtotal_price - cart.total_price);
    const savingsRow = drawer.querySelector('[data-rv-cart-savings-row]');
    savingsRow.hidden = savings === 0;
    drawer.querySelector('[data-rv-cart-savings]').textContent = `−${money(savings)}`;
    renderRecommendations(cart);
  };
  const refresh = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load the cart.');
    const cart = await response.json();
    render(cart);
    return cart;
  };
  const changeLine = async (line, quantity) => {
    setLoading(true); showError('');
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity: Math.max(0, Math.min(10, quantity)) }) });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Unable to update the cart.');
      render(cart);
    } catch (exception) { showError(exception.message); }
    finally { setLoading(false); }
  };
  const flushLineUpdate = async (line) => {
    const state = lineUpdates.get(line);
    if (!state || state.inFlight) return;
    state.inFlight = true;
    const requestedQuantity = state.quantity;
    showError('');
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity: requestedQuantity }) });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Unable to update the cart.');
      if (state.quantity === requestedQuantity) render(cart);
    } catch (exception) {
      showError(exception.message);
      await refresh().catch(() => {});
    } finally {
      state.inFlight = false;
      if (state.quantity !== requestedQuantity) {
        window.clearTimeout(state.timer);
        state.timer = window.setTimeout(() => flushLineUpdate(line), 0);
      }
    }
  };
  const scheduleLineUpdate = (line, quantity) => {
    const nextQuantity = Math.max(1, Math.min(10, quantity));
    const state = lineUpdates.get(line) || { quantity: nextQuantity, timer: 0, inFlight: false };
    state.quantity = nextQuantity;
    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(() => flushLineUpdate(line), 220);
    lineUpdates.set(line, state);
    return nextQuantity;
  };
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    setLoading(true); showError(''); open(event.submitter);
    try {
      const formData = new FormData(form);
      const requestedQuantity = Number(formData.get('quantity') || 1);
      formData.set('quantity', String(Math.max(1, Math.min(10, requestedQuantity))));
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
      await refresh();
      showStatus('Added to your cart');
    } catch (exception) { showError(exception.message); }
    finally { setLoading(false); }
  });
  document.addEventListener('click', async (event) => {
    const cartLink = event.target.closest('a[href$="/cart"][aria-label="Cart"]');
    if (cartLink) { event.preventDefault(); await refresh(); open(cartLink); return; }
    if (event.target.closest('[data-rv-cart-close]')) { close(); return; }
    const item = event.target.closest('.rv-cart-item');
    if (item) {
      const input = item.querySelector('input');
      if (event.target.closest('[data-rv-cart-minus]')) input.value = scheduleLineUpdate(Number(item.dataset.line), Number(input.value) - 1);
      if (event.target.closest('[data-rv-cart-plus]')) input.value = scheduleLineUpdate(Number(item.dataset.line), Number(input.value) + 1);
      if (event.target.closest('[data-rv-cart-remove]')) changeLine(Number(item.dataset.line), 0);
      return;
    }
    const recommendationButton = event.target.closest('[data-rv-recommendation-add]');
    if (recommendationButton) {
      setLoading(true); showError('');
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(recommendationButton.dataset.variantId), quantity: 1 }] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
        await refresh(); showStatus('Added to your cart');
      } catch (exception) { showError(exception.message); }
      finally { setLoading(false); }
    }
  });
  document.addEventListener('change', (event) => {
    const input = event.target.closest('.rv-cart-item__quantity input');
    if (!input) return;
    const item = input.closest('.rv-cart-item');
    input.value = scheduleLineUpdate(Number(item.dataset.line), Number(input.value));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-visible')) close();
  });
  refresh().catch(() => {});
})();
